import { VioletFrame } from '@domains/auth/atoms/VioletFrame/VioletFrame';

import {
    PointsFrameHeader,
    PointsFrameItem,
    PointsFrameList,
    PointsFrameText,
} from './PointsFrame.styled';

interface PointsFrameProps {
    header: string;
    items: string[];
}

export const PointsFrame = ({ header, items }: PointsFrameProps) => {
    return (
        <VioletFrame>
            <PointsFrameHeader>{header}</PointsFrameHeader>
            <PointsFrameList>
                {items.map((item, index) => (
                    <PointsFrameItem key={index}>
                        <PointsFrameText>{item}</PointsFrameText>
                    </PointsFrameItem>
                ))}
            </PointsFrameList>
        </VioletFrame>
    );
};
